import { useTranslation } from "@pancakeswap/localization";
import { styled } from "styled-components";
import { Spinner, Text, ColumnCenter, AutoColumn } from "@pancakeswap/uikit";

export function ConfirmationPendingContent({ pendingText }: { pendingText?: string }) {
  const { t } = useTranslation();
  return (
    <div>
      <div className={"flex items-center justify-center mb-6"}>
        <Spinner className={"size-24"} />
      </div>
      <AutoColumn gap="12px" justify="center">
        {pendingText ? (
          <>
            <Text fontSize="20px">{t("Waiting For Confirmation")}</Text>
            <AutoColumn gap="12px" justify="center">
              <Text bold small textAlign="center">
                {pendingText}
              </Text>
            </AutoColumn>
          </>
        ) : null}
        <Text small color="textSubtle" textAlign="center">
          {t("Confirm this transaction in your wallet")}
        </Text>
      </AutoColumn>
    </div>
  );
}
